
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.338","height":"7.841"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_27458","data-name":"Group 27458","transform":"translate(12.794 -3.08)"}},[_c('g',{attrs:{"id":"Group_22627","data-name":"Group 22627"}},[_c('g',{attrs:{"id":"Group_27433","data-name":"Group 27433","transform":"translate(-1547.213 -198.195)"}},[_c('g',{attrs:{"id":"Group_27430","data-name":"Group 27430","transform":"translate(1534.419 201.275)"}},[_c('g',{attrs:{"id":"Group_27430-2","data-name":"Group 27430","fill":"#5c8df5"}},[_c('path',{attrs:{"id":"Path_20467","data-name":"Path 20467","d":"M228.444 410.189l-.009-.022h.009a.587.587 0 00-.063-.124c-.271-.579-1.223-1.876-4.163-1.9-2.94.025-3.893 1.322-4.164 1.9a.588.588 0 00-.063.124H220l-.009.022a.618.618 0 00.526.941h7.4a.618.618 0 00.526-.941z","transform":"translate(-219.899 -403.289)"}}),_c('circle',{attrs:{"id":"Ellipse_439","data-name":"Ellipse 439","cx":"2.425","cy":"2.425","r":"2.425","transform":"translate(1.893)"}})])]),_c('g',{attrs:{"id":"Group_27431","data-name":"Group 27431","transform":"translate(1542.823 202.148)","fill":"none","stroke":"#5c8df5","stroke-linecap":"round","stroke-width":"1.5"}},[_c('line',{attrs:{"id":"Line_580","data-name":"Line 580","x2":"3.183","transform":"translate(0 1.592)"}}),_c('line',{attrs:{"id":"Line_581","data-name":"Line 581","y1":"3.183","transform":"translate(1.592)"}})])])])])])
          )
        }
      }
    